import { Controller } from "@hotwired/stimulus";

// Populates the Rank dropdown when Discipline is selected (Assign Rank drawer).
export default class extends Controller {
  static targets = ["discipline", "rank"];
  static values = { rankData: Array };

  connect() {
    this.updateRanks();
  }

  updateRanks() {
    if (!this.hasDisciplineTarget || !this.hasRankTarget) return;
    const disciplineSelect = this.disciplineTarget;
    const rankSelect = this.rankTarget;
    const groupId = disciplineSelect?.value;

    rankSelect.innerHTML = '<option value="">Choose rank…</option>';
    rankSelect.disabled = true;

    if (!groupId || !this.hasRankDataValue) return;

    const group = this.rankDataValue.find((g) => String(g.id) === String(groupId));
    if (group?.ranks) {
      group.ranks.forEach((r) => {
        const opt = document.createElement("option");
        opt.value = r.id;
        opt.textContent = r.name;
        rankSelect.appendChild(opt);
      });
      rankSelect.disabled = false;
    }
  }
}
